import React, { useState } from "react";
import {
  Button,
  Typography,
  Box,
  Chip,
} from "@material-ui/core";
import { FaBuilding } from "react-icons/fa";
import { useAuth } from "../../../../../../contexts/auth";
import { useOrgao } from "../../../../../../contexts/orgao";
import { useUserOrgaos } from "../../../../../../services/api-tansquery/user/user-orgaos";
import SwitchOrgaoModal from "../SwitchOrgaoModal";
import { useOrgaoSelectorStyles } from "./styles";

export default function OrgaoSelector() {
  const classes = useOrgaoSelectorStyles();
  const { adminUser } = useAuth();
  const { currentOrgaoId } = useOrgao();
  const { data: userOrgaosData } = useUserOrgaos();
  const [modalOpen, setModalOpen] = useState(false);

  const userOrgaosFromAPI = userOrgaosData?.user_orgaos || [];
  
  const userOrgaosFromAdminUser = adminUser?.orgaos?.map(item => ({
    id: item.orgao.id,
    nome: item.orgao.nome,
    sigla: item.orgao.sigla,
    perfil: item.perfil
  })) || [];
  
  const allOrgaos = [...userOrgaosFromAPI, ...userOrgaosFromAdminUser];
  
  const userOrgaos = Array.from(
    new Map(allOrgaos.map(item => [item.id, item])).values()
  );
  
  const currentOrgao = currentOrgaoId 
    ? userOrgaos.find(org => org.id === currentOrgaoId)
    : (adminUser?.orgao_usuario || adminUser?.orgaos?.[0]?.orgao || userOrgaos[0]);
  
  const userOrgao = currentOrgao || adminUser?.orgao_usuario || adminUser?.orgaos?.[0]?.orgao;
  
  const canSwitchOrgao = adminUser?.permissions?.some(permission => 
    ['Administrador de Atendimento', 'Gerente de Atendimento'].includes(permission)
  );

  if (!canSwitchOrgao || userOrgaos.length <= 1) {
    return null;
  }

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleOpenModal}
        className={classes.button}
        startIcon={<FaBuilding />}
      >
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography variant="caption" color="textSecondary">
            Órgão atual
          </Typography>
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>
            {userOrgao?.sigla || 'N/A'}
          </Typography>
        </Box>
        {userOrgaos.length > 1 && (
          <Chip
            label={userOrgaos.length}
            size="small"
            color="primary"
            style={{ marginLeft: 8 }}
          />
        )}
      </Button>
      <SwitchOrgaoModal open={modalOpen} onClose={handleCloseModal} />
    </>
  );
}

